import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const RequireAdmin = ({ children }) => {
  const { user } = useAuth();
  if (user === undefined) {
    return <div className="min-h-screen grid place-items-center bg-[#FAF7F2] text-[#2E1B16]/50 font-body">Loading…</div>;
  }
  if (!user || user.role !== "admin") return <Navigate to="/admin/login" replace />;
  return children;
};

export default RequireAdmin;
